import { Grid, Typography } from "@material-ui/core";
import { ReferenceInput, SelectInput, useDataProvider } from "react-admin";
import React, { useEffect } from "react";
import { SchoolIdSelected } from "../../../utils/tools";
import { useField } from "react-final-form";
import moment from "moment";
import {
  getBusScheduleDays,
  getBusScheduleType,
} from "../../busSchedules/util";
import Alert from "@material-ui/lab/Alert";
import { AlertTitle } from "@material-ui/lab";

const WaveSelectionAndWaveInfo = () => {
  const provider = useDataProvider();
  const schoolIdSelected = SchoolIdSelected();

  const busScheduleIdField = useField("busScheduleId");
  const busScheduleField = useField("busSchedule");
  const schoolField = useField("school");

  const routesField = useField("routes");
  const droppedLocationsField = useField("droppedLocations");
  const studentsField = useField("students");

  useEffect(() => {
    if (busScheduleIdField.input.value) {
      provider
        .getOne("busSchedules", { id: busScheduleIdField.input.value })
        .then(({ data: busSchedule }) => {
          busScheduleField.input.onChange(busSchedule);
        });

      provider
        .getOne("schools", { id: schoolIdSelected })
        .then(({ data: school }) => {
          schoolField.input.onChange(school);
        });
    }
  }, [busScheduleIdField.input.value]);

  return (
    <>
      <Grid item xs={12}>
        <Typography variant="subtitle2">Wave</Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <ReferenceInput
          source="busScheduleId"
          reference="busSchedules"
          label="Select Wave *"
          filter={{
            SchoolId: Number(schoolIdSelected),
            HasRoutePlan: false,
          }}
          onChange={() => {
            droppedLocationsField.input.onChange([]);
            routesField.input.onChange([]);
            studentsField.input.onChange([]);
          }}
        >
          <SelectInput
            optionText={(record) =>
              `${record.name} | ${getBusScheduleType(record.type)}`
            }
          />
        </ReferenceInput>
      </Grid>

      <Grid item xs={12} md={4}>
        {busScheduleField.input.value ? (
          <Alert severity="info">
            <AlertTitle>Wave Info</AlertTitle>

            <Typography variant="body2">
              {busScheduleField.input.value
                ? `${busScheduleField.input.value.type === "to_school" ? "Arrival Time" : "Departure Time"} : ${moment(
                    busScheduleField.input.value.arrivalTime,
                    "HH:mm",
                  ).format("HH:mm")}`
                : ""}
            </Typography>

            <Typography variant="body2" gutterBottom>
              Days of the Weeks :{" "}
              {busScheduleField.input.value
                ? getBusScheduleDays(busScheduleField.input.value)
                : ""}
            </Typography>
          </Alert>
        ) : (
          <></>
        )}
      </Grid>

      <Grid item xs={12} md={4}></Grid>
    </>
  );
};

export default WaveSelectionAndWaveInfo;
